export function getExtension(path) {
  var filename = path
    .split("\\")
    .pop()
    .split("/")
    .pop();
  return filename.substr(
    (Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1
  );
}
